import './HomePage.css';

import React, { useState, useEffect, useContext } from 'react';
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore'; // <-- NUEVOS IMPORTS

import logo from '../../assets/GoesGreen-300x74.png';
import AnimatedLogo from '../../components/AnimatedLogo/AnimatedLogo';
import { AuthContext } from '../../services/AuthContext';

const APPS = {
  TABLEROS: 'tableros',
  CAUCHARI: 'cauchari_cna',
  PT8: 'pt8',
  INDISP: 'indisponibilidades',
};

const HomePage = () => {
  const navigate = useNavigate();
  // <-- Asegúrate de extraer 'db' del contexto
  const { user, db, loginWithMicrosoft, loginWithGoogle, logout, loading, firebaseUid } =
    useContext(AuthContext);

  const [showLogo, setShowLogo] = useState(true);
  const [readyToHide, setReadyToHide] = useState(false);
  const [isPortrait, setIsPortrait] = useState(false);
  const isGoogleUser = user?.provider === 'google';
  const isMicrosoftUser = user && !isGoogleUser;

  const [selectedApp, setSelectedApp] = useState(null);
  const [codeInput, setCodeInput] = useState('');
  const [codeError, setCodeError] = useState('');
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  
  // <-- ESTADO PARA SABER SI ES ADMIN
  const [isAdmin, setIsAdmin] = useState(false);

  const needsLogin = !user;

  const checkOrientation = () => {
    const isPortraitOrientation =
      window.matchMedia('(orientation: portrait)').matches;
    setIsPortrait(isMobile && isPortraitOrientation);
  };

  // <-- EFECTO PARA VERIFICAR SI ES ADMIN AL INICIAR SESIÓN
  useEffect(() => {
    const checkAdminStatus = async () => {
      if (user && firebaseUid && db) {
        try {
          const userRef = doc(db, 'userRoles', firebaseUid);
          const userSnap = await getDoc(userRef);
          if (userSnap.exists() && userSnap.data().admin === true) {
            setIsAdmin(true);
          } else {
            setIsAdmin(false);
          }
        } catch (error) {
          console.error("Error verificando rol de administrador:", error);
          setIsAdmin(false);
        }
      } else {
        setIsAdmin(false);
      }
    };

    checkAdminStatus();
  }, [user, db]);

  useEffect(() => {
  if (!user) return;

  const target = sessionStorage.getItem('pendingNavigation');

  if (!target) return;

  sessionStorage.removeItem('pendingNavigation');

  navigate(target, { replace: true });
}, [user, navigate]);

  useEffect(() => {
    checkOrientation();
    window.addEventListener('resize', checkOrientation);
    window.addEventListener('orientationchange', checkOrientation);
    return () => {
      window.removeEventListener('resize', checkOrientation);
      window.removeEventListener('orientationchange', checkOrientation);
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setReadyToHide(true), 5000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (readyToHide) setShowLogo(false);
  }, [readyToHide]);

  // -------------------------
  // VOLVER AL MENU
  // -------------------------
  const resetView = () => {
  setSelectedApp(null);
  setCodeInput('');
  setCodeError('');

  sessionStorage.removeItem('pendingNavigation');
};

  // -------------------------
  // CLICK APP
  // -------------------------
  const handleAppClick = async (app) => {

  // TABLEROS
  if (app === APPS.TABLEROS) {
    if (isGoogleUser) {
      await loginWithMicrosoft();
      return;
    }

    if (!user) {
      await loginWithMicrosoft();
      return;
    }
    
    setSelectedApp(app);

    return;
  }
  setSelectedApp(app);

  // usuario ya logueado
  if (user) {
    if (app === APPS.CAUCHARI) navigate('/cauchari_cna');
    if (app === APPS.PT8) navigate('/pt8');
    if (app === APPS.INDISP) navigate('/indisponibilidades');
    return;
  }
};

  // -------------------------
  // LOGIN
  // -------------------------
  const handleLogin = async (provider) => {
  if (isAuthenticating) return;

  setIsAuthenticating(true);

  try {
    let target = null;

    if (selectedApp === APPS.CAUCHARI) {
      target = '/cauchari_cna';
    }

    if (selectedApp === APPS.PT8) {
      target = '/pt8';
    }

    if (selectedApp === APPS.INDISP) {
      target = '/indisponibilidades';
    }

    if (target) {
      sessionStorage.setItem('pendingNavigation', target);
    }

    if (provider === 'ms') {
      await loginWithMicrosoft();
    }

    if (provider === 'google') {
      await loginWithGoogle();
    }

  } catch (err) {
    setCodeError('Error login: ' + (err?.message || err));
  } finally {
    setIsAuthenticating(false);
  }
};

const handleLogout = async () => {
  sessionStorage.removeItem('pendingNavigation');
  await logout();
};

  // -------------------------
  // TABLEROS CODE
  // -------------------------
  const handleCodeSubmit = () => {
    const normalized = codeInput.trim().toLowerCase();

    const allowed = [
      'cauchari',
      'arrebeef',
      'demo',
      'helios',
      'gu',
      'arrebeef_en',
      'performancect',
      'cauchari_lite',
    ];

    if (allowed.includes(normalized)) {
      navigate(normalized);
    } else {
      setCodeError('Código inválido.');
    }
  };

  return (
    <div className="container">
      <AnimatedLogo visible={showLogo} />

      {!showLogo && (
        <>
          <img src={logo} alt="GoesGreen Logo" className="static-logo" />

          {/* ---------------- MENU O CONTENIDO ---------------- */}
          {!selectedApp && (
            <div className="code-entry">
              <div className="home-buttons">

                <button onClick={() => handleAppClick(APPS.TABLEROS)}>
                  Tableros I4
                </button>

                <button onClick={() => handleAppClick(APPS.CAUCHARI)}>
                  Control Normativo Ambiental
                </button>

                <button onClick={() => handleAppClick(APPS.PT8)}>
                  Libro de Novedades PT8
                </button>

                <button onClick={() => handleAppClick(APPS.INDISP)}>
                  Indisponibilidades
                </button>

              </div>
            </div>
          )}

          {/* ---------------- TABLEROS FLOW ---------------- */}
          {selectedApp === APPS.TABLEROS && (
            <div className="code-entry">

              {needsLogin ? (
                <button onClick={() => loginWithMicrosoft()}>
                  Iniciar sesión con Microsoft
                </button>
              ) : (
                <>
                  <h2>Ingresa tu código de acceso</h2>

                  <input
                    type="text"
                    value={codeInput}
                    onChange={(e) => {
                      setCodeInput(e.target.value);
                      setCodeError('');
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') handleCodeSubmit();
                    }}
                  />

                  <button onClick={handleCodeSubmit}>
                    Ingresar
                  </button>

                  {codeError && (
                    <div className="error-message">{codeError}</div>
                  )}
                </>
              )}

              <button onClick={resetView} style={{ marginTop: '1rem' }}>
                Volver
              </button>
            </div>
          )}

          {/* ---------------- OTHER APPS FLOW ---------------- */}
          {selectedApp && selectedApp !== APPS.TABLEROS && (
            <div className="code-entry">

              {needsLogin ? (
                <div className="buttons-login">

                  <button onClick={() => handleLogin('ms')}>
                    Login Microsoft
                  </button>

                  <button onClick={() => handleLogin('google')}>
                    Login Google
                  </button>

                </div>
              ) : (
                <p>Redirigiendo...</p>
              )}
              <div className="buttons-login-back">
              <button onClick={resetView} >
                Volver
              </button>
              </div>

            </div>
          )}

          {isAdmin && (
            <div className="admin-button">
              <button onClick={() => navigate('/usuarios')}>
                Administrar permisos
              </button>
            </div>
          )}

          {/* ---------------- LOGOUT ---------------- */}
          {user && (
            <div className="logout-button">
              <button onClick={handleLogout}>
                Cerrar sesión
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default HomePage;